/**
 * Solo sauna PDP: per-variant prices on block swatches + price row updates.
 */
(function () {
    function formatMoney(cents) {
      const format =
        window.theme?.moneyFormat ||
        (typeof Shopify !== 'undefined' && Shopify.money_format) ||
        '${{amount}}';
  
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format);
      }
  
      return '$' + (cents / 100).toFixed(2);
    }
  
    function initSoloGallery(section) {
      const gallery = section.querySelector('.product-gallery--solo-sauna');
      if (!gallery) return;

      const carousel = gallery.querySelector('media-carousel');
      const pagination = gallery.querySelector('[data-solo-sauna-gallery-pagination]');
      if (!carousel || !pagination) return;

      const dots = Array.from(pagination.querySelectorAll('.solo-sauna-gallery-pagination__dot'));
      if (dots.length < 2) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      function syncDots(selectedIndex) {
        dots.forEach((dot) => {
          const index = parseInt(dot.getAttribute('data-carousel-index'), 10);
          dot.setAttribute('aria-current', index === selectedIndex ? 'true' : 'false');
        });
      }

      function applyFilter(filteredIndexes) {
        let visible = 0;
        dots.forEach((dot) => {
          const index = parseInt(dot.getAttribute('data-carousel-index'), 10);
          const hidden = Array.isArray(filteredIndexes) && filteredIndexes.includes(index);
          dot.hidden = hidden;
          if (!hidden) visible += 1;
        });
        pagination.hidden = visible < 2;
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.getAttribute('data-carousel-index'), 10);
          if (!Number.isNaN(index)) {
            carousel.select(index, { animate: true });
          }
        });
      });

      carousel.addEventListener('carousel:change', (event) => {
        syncDots(event.detail.index);
      });

      carousel.addEventListener('carousel:filter', (event) => {
        applyFilter(event.detail.filteredIndexes);
      });

      syncDots(carousel.selectedIndex);
    }

    function initSection(section) {
      initSoloGallery(section);

      const formId = section.querySelector('form[is="product-form"]')?.id;
      if (!formId) return;
  
      const form = document.getElementById(formId);
      const variantsScript = section.querySelector('[data-solo-sauna-variants]');
      if (!form || !variantsScript) return;
  
      let variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }
  
      const priceById = Object.fromEntries(variants.map((v) => [String(v.id), v]));
  
      function decorateVariantCards() {
        section.querySelectorAll('.solo-sauna-variant-picker .block-swatch').forEach((label) => {
          if (label.querySelector('[data-solo-sauna-variant-price]')) return;
  
          const input =
            label.previousElementSibling?.matches?.('input[type="radio"]') &&
            label.previousElementSibling.name?.startsWith('option')
              ? label.previousElementSibling
              : null;
  
          if (!input) return;
  
          const optionIndex = parseInt(input.name.replace('option', ''), 10) - 1;
          const match = variants.find((v) => v.options[optionIndex] === input.value);
          if (!match) return;
  
          const priceEl = document.createElement('span');
          priceEl.className = 'solo-sauna-variant-card__price';
          priceEl.setAttribute('data-solo-sauna-variant-price', '');
          priceEl.textContent = formatMoney(match.price);
          label.appendChild(priceEl);
        });
      }
  
      function updateMainPrice(variant) {
        const priceHost = section.querySelector('[data-solo-sauna-price]');
        if (!priceHost || !variant) return;
        const saleEl = priceHost.querySelector('.text-on-sale, sale-price');
        const amount = formatMoney(variant.price);
        if (saleEl) {
          saleEl.textContent = amount;
        } else {
          const fallback = priceHost.querySelector('.price-list, .h4, .text-lg');
          if (fallback) fallback.textContent = amount;
        }
      }

      decorateVariantCards();
  
      form.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (variant) updateMainPrice(variant);
      });
    }

    function initSoloPricing(section) {
      const form = section.querySelector('form[is="product-form"]');
      const shippingValuesScript = section.querySelector('[data-solo-sauna-free-shipping-values]');
      if (!form || !shippingValuesScript) return;

      let shippingLabelByVariantId = {};

      try {
        const shippingRows = JSON.parse(shippingValuesScript.textContent);
        shippingLabelByVariantId = Object.fromEntries(
          shippingRows.map((row) => [String(row.id), row.label || ''])
        );
      } catch (e) {
        return;
      }

      function updateShippingValue(variant) {
        const valueEl = section.querySelector('[data-solo-sauna-shipping-value]');
        if (!valueEl || !variant) return;

        const label = shippingLabelByVariantId[String(variant.id)] || '';

        if (label) {
          valueEl.textContent = label;
          valueEl.hidden = false;
        } else {
          valueEl.textContent = '';
          valueEl.hidden = true;
        }
      }

      form.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (variant) updateShippingValue(variant);
      });
    }
  
    function init() {
      document.querySelectorAll('.shopify-section--main-product').forEach((section) => {
        initSoloGallery(section);
        if (!section.querySelector('.solo-sauna-pdp')) return;
        initSection(section);
        initSoloPricing(section);
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('shopify-section--main-product')) {
        initSoloGallery(event.target);
        initSection(event.target);
        if (event.target.querySelector('.solo-sauna-pdp')) {
          initSoloPricing(event.target);
        }
      }
    });
  })();
  